import React from "react";

import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import styles from "@styles/integrations.module.scss"
import { Context } from "pages/Integrations";
import { Checkbox } from "@components";

export default class NetLogicDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      netlogic_url: "",
      netlogic_token: "",
      netlogic_type: "",
      netlogic_employee: "",
      tenderMediaIncrement: "",
      tenderMediaClosing: "",
      sendTableNameObservation: false,
      sendTableCodeObservation: false,
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "external_credentials"
    );
    const netLogicConfigs = externalCredentials.net_logic || {};

    if (Object.keys(netLogicConfigs).length > 0) {
      this.setState({
        netlogic_url: netLogicConfigs.netlogic_url,
        netlogic_token: netLogicConfigs.netlogic_token,
        netlogic_type: netLogicConfigs.netlogic_type,
        netlogic_employee: netLogicConfigs.netlogic_employee,
        tenderMediaIncrement: netLogicConfigs.tenderMediaIncrement,
        tenderMediaClosing: netLogicConfigs.tenderMediaClosing,
        tenderMediaWaiter: netLogicConfigs.tenderMediaWaiter,
        sendTableNameObservation: netLogicConfigs.sendTableNameObservation,
        sendTableCodeObservation: netLogicConfigs.sendTableCodeObservation,
        callWaiterSku: netLogicConfigs.callWaiterSku || "",
      });
    }

    this.setState({
      loadingPage: false,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const {
        netlogic_url,
        netlogic_token,
        netlogic_type,
        netlogic_employee,
        tenderMediaIncrement,
        tenderMediaClosing,
        tenderMediaWaiter,
        sendTableNameObservation,
        sendTableCodeObservation,
        callWaiterSku,
      } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const externalCredentials =
        await EnvironmentsAPI.getConfigurationsByAlias(
          environmentId,
          "external_credentials"
        );
      const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "external_credentials",
        {
          ...externalCredentials,
          net_logic: {
            netlogic_url,
            netlogic_token,
            netlogic_type,
            netlogic_employee,
            tenderMediaIncrement,
            tenderMediaClosing,
            tenderMediaWaiter,
            sendTableNameObservation,
            sendTableCodeObservation, 
            callWaiterSku,
          },
        }
      );

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const {
      loading,
      loadingPage,
      netlogic_url,
      netlogic_token,
      netlogic_type,
      netlogic_employee,
      tenderMediaIncrement,
      tenderMediaClosing,
      tenderMediaWaiter,
      sendTableNameObservation,
      sendTableCodeObservation, 
      callWaiterSku,
    } = this.state;
    const { visible, onClose } = this.props;

    const isValid = netlogic_url?.length > 12 && netlogic_token?.length > 3;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Conector NetLogic"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Input
              design="two"
              className="mb-20"
              floatLabel="URL"
              value={netlogic_url}
              onChange={(e) => this.setState({ netlogic_url: e.target.value })}
            />
            <Input
              design="two"
              className="mb-20"
              floatLabel="Token"
              value={netlogic_token}
              onChange={(e) =>
                this.setState({ netlogic_token: e.target.value })
              }
            />
            <Input
              design="two"
              className="mb-20"
              floatLabel="Tipo"
              value={netlogic_type}
              onChange={(e) =>
                this.setState({ netlogic_type: e.target.value })
              }
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="EmployeeId Qrcode"
              value={netlogic_employee}
              onChange={(e) =>
                this.setState({ netlogic_employee: e.target.value })
              }
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Tender Media (Manter a mesa aberta)"
              value={tenderMediaIncrement}
              onChange={(e) =>
                this.setState({ tenderMediaIncrement: e.target.value })
              }
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Tender Media (Impressão do pré-fechamento)"
              value={tenderMediaClosing}
              onChange={(e) =>
                this.setState({ tenderMediaClosing: e.target.value })
              }
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Tender Media (Chamar garçom)"
              value={tenderMediaWaiter}
              onChange={(e) =>
                this.setState({ tenderMediaWaiter: e.target.value })
              }
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="SKU do produto (Chamar garçom)"
              value={callWaiterSku}
              onChange={(e) =>
                this.setState({ callWaiterSku: e.target.value })
              }
            />

            <Checkbox
              name="sendTableCodeObservation"
              design="two"
              className="mb-20"
              checked={sendTableCodeObservation}
              onChange={() =>
                this.setState({
                  sendTableCodeObservation: !sendTableCodeObservation,
                })
              }
            >
              Enviar código da mesa na observação?
            </Checkbox>

            <Checkbox
              name="sendTableNameObservation"
              design="two"
              className="mb-20"
              checked={sendTableNameObservation}
              onChange={() =>
                this.setState({
                  sendTableNameObservation: !sendTableNameObservation,
                })
              }
            >
              Enviar nome da mesa na observação?
            </Checkbox>

          </div>
        )}
      </Drawer>
    );
  }
}
